import {css} from 'lit'; export default css`goto-user-presence-note-field{display:block;margin-bottom:var(--goto-spacing-09)}:host chameleon-dialog{--goto-dialog-z-index:60000}`;
    